import React, { useEffect, useState, useRef, useMemo } from "react";
import withRouter from "components/Common/withRouter";
import TableContainer from "../../../components/Common/TableContainer";
import {
  Card,
  CardBody,
  Col,
  Container,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  UncontrolledTooltip,
  Button,
  Table
} from "reactstrap";
import { useFormik } from "formik";
import { NameSurname } from "./contactlistCol";
import { ExportToExcel } from '../../../ExportToExcel';

import jsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";

//Import Breadcrumb
import Breadcrumbs from "components/Common/Breadcrumb";
import DeleteModal from "components/Common/DeleteModal";

import {
  getAuthority as onGetAuthority,
  deleteUser as onDeleteUser,
} from "store/contacts/actions";
import { isEmpty } from "lodash";

//redux
import { useSelector, useDispatch } from "react-redux";

const ContactsList = props => {

  document.title = "Cevaplanan Testler | Bee Education ADMIN PANELI";

  const dispatch = useDispatch();
  const [contact, setContact] = useState();
  
  // Detay Modalı için State'ler
  const [modalResults, setModalResults] = useState(false);
  const [selectedUserTests, setSelectedUserTests] = useState([]);
  const [selectedUserName, setSelectedUserName] = useState("");

  const { users } = useSelector(state => ({
    users: state.contacts.authlist,
  }));

  // --- VERİ GRUPLAMA MANTIĞI ---
  // Gelen tüm test sonuçlarını Kullanıcı ID'sine göre grupluyoruz.
  const groupedData = useMemo(() => {
    if (!users) return [];
    
    const groups = {};
    
    users.forEach(test => {
      // Kullanıcı ID yoksa Device ID'yi anahtar olarak kullan
      const key = test.Users_ID ? `user_${test.Users_ID}` : `device_${test.Device_ID}`;
      
      if (!groups[key]) {
        groups[key] = {
          // Gruplama için ana bilgiler
          Users: test.Users, 
          Users_ID: test.Users_ID,
          Device_ID: test.Device_ID,
          TotalTests: 0,
          LastTestDate: test.Created_DateTime,
          AllTests: [] // O kullanıcının tüm testlerini burada biriktiriyoruz
        };
      }
      
      groups[key].TotalTests += 1;
      groups[key].AllTests.push(test);
      
      // En son test tarihini güncelle (Sıralama için gerekirse)
      if (new Date(test.Created_DateTime) > new Date(groups[key].LastTestDate)) {
        groups[key].LastTestDate = test.Created_DateTime;
      }
    });

    return Object.values(groups);
  }, [users]);


  // PDF Export (Detaylı liste dökümü)
  const exportPDF = () => {
    const unit = "pt";
    const size = "A4";
    const orientation = "portrait";
    const doc = new jsPDF(orientation, unit, size);

    const title = "Cevaplanan Testler Listesi";
    doc.text(title, 40, 40);

    const headers = [["Kullanıcı", "Tarih", "Test", "Puan"]];

    const data = users.map(item => {
      // Kullanıcı Bilgisi
      let userInfo = item.Device_ID;
      if (item.Users) {
         userInfo = item.Users.MailAdress || item.Users.Users_TelephoneNumber || item.Users.Users_NameSurname;
      }

      // Test Adı Oluşturma
      let testName = "";
      if (item.Deneme_Check === true) {
         testName = "Deneme Sınavı";
      } else {
         const cat = item.Category?.Category_Title || "";
         const type = item.Question_Type?.Question_Type_Title || "";
         testName = `${cat} - ${type}`;
      }

      // Puan Formatı (5/10)
      const totalQuestions = (item.TrueCount || 0) + (item.FalseCount || 0);
      const score = `${item.TrueCount || 0}/${totalQuestions}`;

      return [
        userInfo,
        moment(item.Created_DateTime).format('DD.MM.YYYY'),
        testName,
        score
      ];
    });

    let content = {
      startY: 50,
      head: headers,
      body: data,
      styles: { font: 'helvetica', fontSize: 8 }
    };

    doc.autoTable(content);
    doc.save("cevaplanan-testler.pdf");
  }

  // --- ANA TABLO SÜTUNLARI (Kullanıcı Listesi) ---
  const columns = useMemo(
    () => [
      {
        Header: "#",
        Cell: () => <input type="checkbox" className="form-check-input" />,
      },
      {
        Header: "Kullanıcı Bilgisi",
        accessor: "UserInfo", 
        filterable: true,
        Cell: cellProps => {
          const row = cellProps.row.original;
          
          if (row.Users) {
            // Mail varsa maili, yoksa telefonu, o da yoksa adı göster
            const displayInfo = row.Users.MailAdress || row.Users.Users_TelephoneNumber || row.Users.Users_NameSurname;
            const subInfo = row.Users.Users_NameSurname; // Altına isim yazabiliriz

            return (
              <div>
                <h5 className="font-size-14 mb-1">{displayInfo}</h5>
                <p className="text-muted mb-0">{subInfo}</p>
              </div>
            );
          } else {
            return (
                <div>
                  <h5 className="font-size-14 mb-1">Misafir Cihaz</h5>
                  <p className="text-muted mb-0 font-size-12">{row.Device_ID}</p>
                </div>
            );
          }
        },
      },
      {
        Header: "Son İşlem Tarihi",
        accessor: "LastTestDate",
        Cell: cellProps => {
            return <>{moment(cellProps.value).format('DD.MM.YYYY HH:mm')}</>
        }
      },
      {
        Header: "Çözülen Test Sayısı",
        accessor: "TotalTests",
        Cell: cellProps => {
            return <span className="badge bg-primary font-size-12">{cellProps.value} Adet</span>
        }
      },
      {
        Header: "İşlemler",
        Cell: cellProps => {
          return (
            <div className="d-flex gap-3">
              <Button
                color="primary"
                size="sm"
                className="btn-rounded"
                onClick={() => {
                  const userData = cellProps.row.original;
                  handleShowResults(userData);
                }}
              >
                <i className="mdi mdi-eye me-1" />
                Sonuçları Gör
              </Button>
            </div>
          );
        },
      },
    ],
    []
  );

  useEffect(() => {
    if (users && !users.length) {
      dispatch(onGetAuthority());
    }
  }, [dispatch, users]);


  // Sonuçları Gör butonuna basınca çalışır
  const handleShowResults = (userData) => {
    // Seçilen kullanıcının testlerini (AllTests arrayini) alıp tarihe göre (yeniden eskiye) sıralayalım
    const sortedTests = userData.AllTests.sort((a,b) => new Date(b.Created_DateTime) - new Date(a.Created_DateTime));
    
    setSelectedUserTests(sortedTests);
    
    // Başlık için isim belirle
    let name = "Misafir Kullanıcı";
    if(userData.Users) {
        name = userData.Users.Users_NameSurname || userData.Users.MailAdress;
    }
    setSelectedUserName(name);
    
    setModalResults(true);
  };

  // Modalı kapat
  const toggleResults = () => {
    setModalResults(!modalResults);
  };


  // Delete işlemleri için gerekli dummy state ve fonksiyonlar (Mevcut yapıyı bozmamak için)
  const [deleteModal, setDeleteModal] = useState(false);
  const handleDeleteUser = () => {
     // Silme işlemi mantığı buraya
    setDeleteModal(false);
  };
  const onPaginationPageChange = page => {
      if (node.current?.props?.pagination?.options) {
        node.current.props.pagination.options.onPageChange(page);
      }
  };
  var node = useRef();


  return (
    <React.Fragment>
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDeleteUser}
        onCloseClick={() => setDeleteModal(false)}
      />

      <div className="page-content">
        <Container fluid>
          <Breadcrumbs title="Yönetim" breadcrumbItem="Cevaplanan Testler" />
          <Row>
            <Col lg="12">
              <Card>
                <CardBody>
                  <div className="d-flex gap-2 mb-3">
                    <ExportToExcel apiData={users} fileName={"cevaplanan_testler"} />
                    <button className="btn btn-danger" onClick={exportPDF}>
                      PDF Olarak Dışa Aktar
                    </button>
                  </div>

                  {/* ANA TABLO: SADECE KULLANICILAR */}
                  <TableContainer
                    columns={columns}
                    data={groupedData} // Gruplanmış veriyi gönderiyoruz
                    isGlobalFilter={true}
                    isAddAuthList={false}
                    customPageSize={10}
                    className="custom-header-css"
                  />

                  {/* DETAY MODALI: KULLANICIYA AİT TESTLER */}
                  <Modal isOpen={modalResults} toggle={toggleResults} size="lg" scrollable={true}>
                    <ModalHeader toggle={toggleResults}>
                        <span className="text-primary">{selectedUserName}</span> - Sınav Geçmişi
                    </ModalHeader>
                    <ModalBody>
                        <div className="table-responsive">
                            <Table className="table mb-0 align-middle table-hover">
                                <thead className="table-light">
                                    <tr>
                                        <th>Tarih</th>
                                        <th>Test / Kategori</th>
                                        <th>Doğru / Yanlış</th>
                                        <th>Puan (D/T)</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {selectedUserTests.map((test, index) => {
                                        // Test Adını Düzenleme
                                        let testName = "";
                                        let subInfo = "";

                                        if (test.Deneme_Check === true) {
                                            testName = "Deneme Sınavı";
                                            if(test.Category?.Category_Title) subInfo = test.Category.Category_Title;
                                        } else {
                                            // Quiz Set1 - Kelime gibi bir yapı
                                            testName = test.Category?.Category_Title || "Genel";
                                            subInfo = test.Question_Type?.Question_Type_Title;
                                        }

                                        // Skor Hesaplama (5/10 formatı)
                                        const trueC = test.TrueCount || 0;
                                        const falseC = test.FalseCount || 0;
                                        const total = trueC + falseC;

                                        return (
                                            <tr key={index}>
                                                <td>
                                                    {moment(test.Created_DateTime).format('DD.MM.YYYY')} 
                                                    <br/>
                                                    <small className="text-muted">{moment(test.Created_DateTime).format('HH:mm')}</small>
                                                </td>
                                                <td>
                                                    <span className="fw-bold">{testName}</span>
                                                    {subInfo && <div className="text-muted font-size-12">{subInfo}</div>}
                                                </td>
                                                <td>
                                                    <span className="text-success">{trueC} D</span> / <span className="text-danger">{falseC} Y</span>
                                                </td>
                                                <td>
                                                    <span className="badge bg-info font-size-13 p-2">
                                                        {trueC} / {total}
                                                    </span>
                                                </td>
                                            </tr>
                                        )
                                    })}
                                    
                                    {selectedUserTests.length === 0 && (
                                        <tr>
                                            <td colSpan="4" className="text-center">Kayıt bulunamadı.</td>
                                        </tr>
                                    )}
                                </tbody>
                            </Table>
                        </div>
                    </ModalBody>
                  </Modal>

                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ContactsList);